import axios from 'axios';
import { PAGES_ROOT, WORKFLOW_ROOT } from 'config/api';
import { NON_WORKFLOW_PAGES } from 'config/workflow';

const groupActions = {
  API_ACTION: 'GROUP_API_ACTION',
  BACK: 'GROUP_BACK',
  HANDLE_VERIFICATION_OPTIONS: 'GROUP_HANDLE_VERIFICATION_OPTIONS',
  NEXT: 'GROUP_NEXT',
  NEXT_FAILED: 'GROUP_NEXT_FAILED',
  NEXT_SUCCESS: 'GROUP_NEXT_SUCCESS',
  PROD_START_NEXT: 'GROUP_PROD_START_NEXT',
  SAVE: 'GROUP_SAVE',
  UPDATE: 'GROUP_UPDATE',
  UPDATE_FAILED: 'GROUP_UPDATE_FAILED',
  UPDATE_SUCCESS: 'GROUP_UPDATE_SUCCESS',
  UPLOAD: 'GROUP_UPLOAD',
  UPLOAD_FAILED: 'GROUP_UPLOAD_FAILED',
  UPLOAD_SUCCESS: 'GROUP_UPLOAD_SUCCESS',

  apiAction: (action) => ({
    payload: {
      request: (pageName, data) => () =>
        axios({
          data,
          method: 'POST',
          url: `${PAGES_ROOT}/${pageName}/groups/${action}`,
        }),
    },
    type: groupActions.UPLOAD,
  }),
  back: () => ({
    type: groupActions.BACK,
  }),
  handleVerificationOptions: (groupName, mobileField) => ({
    payload: {
      groupName,
      mobileField,
    },
    type: groupActions.HANDLE_VERIFICATION_OPTIONS,
  }),

  next: (group) => ({
    payload: {
      group,
      request: (page, data) => () =>
        axios.post(
          !NON_WORKFLOW_PAGES.includes(page)
            ? `${PAGES_ROOT}/${page}/groups/${group}`
            : `${WORKFLOW_ROOT}/${page}/groups/${group}`,
          { ...data, group },
        ),
    },
    type: groupActions.NEXT,
  }),

  nextFailed: (data, fields) => ({
    payload: { data, fields },
    type: groupActions.NEXT_FAILED,
  }),

  nextSuccess: (data, nextGroup) => ({
    payload: { data, nextGroup },
    type: groupActions.NEXT_SUCCESS,
  }),

  prodStartNext: () => ({
    type: groupActions.PROD_START_NEXT,
  }),

  save: (groupName) => ({
    payload: {
      request: (pageName, data) => () =>
        axios.post(`${PAGES_ROOT}/${pageName}/groups/${groupName}/actions/save`, data),
    },
    type: groupActions.SAVE,
  }),

  update: (group, index) => ({
    payload: {
      group,
      index,
      request: (pageName, data) => () => {
        let url = `${PAGES_ROOT}/${pageName}/groups/${group}/actions/update`;
        if (index !== null && index !== undefined) {
          url += `/${index}`;
        }
        return axios.post(url, data);
      },
    },
    type: groupActions.UPDATE,
  }),

  updateFailed: (data, fields) => ({
    payload: { data, fields },
    type: groupActions.UPDATE_FAILED,
  }),

  updateSuccess: (data) => ({
    payload: { data },
    type: groupActions.UPDATE_SUCCESS,
  }),

  upload: (files, back = true) => ({
    payload: {
      files,
      request: (pageName, activeGroup, data) => () =>
        axios({
          data,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'POST',
          url: `${PAGES_ROOT}/${pageName}/groups/${activeGroup}/actions/idupload/${
            back ? 'back' : 'front'
          }`,
        }),
    },
    type: groupActions.UPLOAD,
  }),
  uploadFailed: (data) => ({
    payload: { data },
    type: groupActions.UPLOAD_FAILED,
  }),
  uploadSuccess: (data, activePanel) => ({
    payload: {
      activePanel,
      data,
    },
    type: groupActions.UPLOAD_SUCCESS,
  }),
};

export default groupActions;
